import * as React from "react";
import { useParams } from "react-router-dom";
import { useGetLocationQuery } from "../../store/api/locationApi";
import { LocationDetailForm } from "./detailForm";
import { Loader } from "../../components/layout/loader";
import { IncorrectItem } from "../../components/generic/IncorrectItem/incorrectItem";
import { AccessRestrictedItem } from "../../components/generic/AccessRestrictedItem/accessRestrictedItem";

type RouteParams = "org" | "location";
export const LocationDetailInitializer: React.FC = () => {
  const { org: orgName, location: locationName } = useParams<RouteParams>();

  const selfLink = `/org/${orgName}/location/${locationName}`;

  const { data: location, isLoading, isFetching, isError, error, refetch } = useGetLocationQuery(selfLink, {
    skip: !selfLink,
    refetchOnMountOrArgChange: true,
  });

  if (!location && isLoading) {
    return <Loader />;
  }

  const is403 = isError && (error as any)?.status === 403;
  if (is403) {
    return <AccessRestrictedItem kind="location" />;
  }

  const is404 = isError && (error as any)?.status === 404;
  if (is404 || !location) {
    return <IncorrectItem kind="location" canCreate={false} />;
  }

  return <LocationDetailForm location={location} />;
};
